import React, { Component } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButtons,
  IonButton,
  IonBackButton,
  isPlatform,
  IonIcon,
  withIonLifeCycle,
} from "@ionic/react";
import { chevronBackOutline } from "ionicons/icons";
import { RouteComponentProps, withRouter } from "react-router";

import { App } from "@capacitor/app";
import { Browser } from "@capacitor/browser";

// CSS
import "./HelpCentrePage.css";
import "../../Shared.css";
import "../../../App.css";

// Images
import disclosureRight from "../../assets/Button_Disclosure_Right_Blue@3x.png";
import iconPlay from "../../assets/Button_Video_Play@3x.png";

import onboardingImageDash from "../../assets/Image_OB_v2Dash@3x.png";
import onboardingImageSearching from "../../assets/Image_OB_Searching@3x.png";
import onboardingImageSpeakContent from "../../assets/Image_OB_SpeakContent@3x.png";
import onboardingImageGuidelineUpdates from "../../assets/Image_OB_GuidelineUpdates@3x.png";
import onboardingImagePins from "../../assets/Image_OB_Pins@3x.png";
import onboardingImageParaPassLink from "../../assets/Image_OB_ParaPassLink@3x.png";
import onboardingImageEditDash from "../../assets/Image_OB_EditDash@3x.png";
import onboardingImageSearchFilter from "../../assets/Image_OB_SearchFilter@3x.png";
import onboardingImagePageSearch from "../../assets/Image_OB_PageSearch@3x.png";

// Controllers
import { IHelpCentreItem, IScreenProps, IUser } from "../../Interfaces";
import RemoteDataController from "../../controllers/RemoteDataController";

// Components

type Props = RouteComponentProps<{ id: string; tab: string }> & { screenProps: IScreenProps; features: string[] };
type State = {};

class HelpCentrePage extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {}

  updateCurrentHelpCentrePage(helpCentreItem: IHelpCentreItem | null) {
    this.setState({ currentHelpCentreItem: helpCentreItem });

    if (helpCentreItem != null) {
      this.props.history.push("/dashboard/helpcentre/" + helpCentreItem.id);
    }
  }

  render() {
    let helpCentreItems = this.props.screenProps.helpCentreItems;

    let contentLayout = null;
    // show list of items

    let appName = "JRCALC PLUS";
    if (this.props.screenProps.app === "iCPG") {
      appName = "iCPG";
    } else if (this.props.screenProps.app === "CFR") {
      appName = "CFR PLUS";
    }

    let sections: string[] = [];
    for (let helpCenterItemIndex = 0; helpCenterItemIndex < helpCentreItems.length; helpCenterItemIndex++) {
      let helpCentreItem = helpCentreItems[helpCenterItemIndex];
      if (sections.includes(helpCentreItem.section) === false) {
        sections.push(helpCentreItem.section);
      }
    }

    let sectionListLayout = [];

    for (let section of sections) {
      let sectionLayout = [];

      for (let helpCentreItem of helpCentreItems) {
        if (helpCentreItem.section === section) {
          sectionLayout.push(
            <div className="helpCentreRow" onClick={this.updateCurrentHelpCentrePage.bind(this, helpCentreItem)}>
              <div className="helpCentreRowText">{helpCentreItem.title}</div>
              <img alt="" src={disclosureRight} className="icon-44" />
            </div>
          );
        } else if (helpCentreItem.section == null || helpCentreItem.section === "") {
        }
      }

      if (sectionLayout.length !== 0) {
        sectionListLayout.push(
          <div className="helpCentreSection">
            <div className="helpCentreSectionTitle">
              <div className="globalContentMargin">{section}</div>
            </div>
            <div className="helpCentreSectionContainer globalContentMargin">{sectionLayout}</div>
          </div>
        );
      }

      let faqLink = "https://www.classprofessional.co.uk/faqs/#jrcalc-plus-app";
      let faqText = "https://www.classprofessional.co.uk/faqs/#jrcalc-plus-app";
      if (this.props.screenProps.app === "iCPG") {
        faqLink = "https://www.classprofessional.co.uk/faqs/#icpg-app";
        faqText = "https://www.classprofessional.co.uk/faqs/#icpg-app";
      } else if (this.props.screenProps.app === "CFR") {
        faqLink = "https://www.classprofessional.co.uk/faqs/#cfr-plus-app";
        faqText = "https://www.classprofessional.co.uk/faqs/#cfr-plus-app";
      }

      contentLayout = (
        <div className="helpCentreContent">
          <div>
            <div className="globalContentMargin">
              <div className="helpCentreTitle">How can we help?</div>
              <div className="helpCentreDescription">
                <p>
                  Please find information below on the app features of {appName}, as well as answers to the most
                  frequently asked questions.
                </p>
              </div>
            </div>
          </div>

          {sectionListLayout}

          <div className="globalContentMargin">
            <div className="helpCentreFindOutMore">
              Still can't find the answer you're looking for? Our FAQ can help to answer some issues:{" "}
              <a href={faqLink} target="_blank">
                {faqText}
              </a>
            </div>
          </div>
          <IonButton
            mode="ios"
            className="helpCentreContinueButton greyFilledButton"
            onClick={this.props.screenProps.sendSupportEmail.bind(this, "Subscription Support")}
          >
            Contact support
          </IonButton>
        </div>
      );
    }

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar mode="ios" className="navBar">
            <IonButtons slot="start" className="headerButtonText" color="#FFFFFF">
              <IonBackButton defaultHref={`/${this.props.match.params.tab}`} class="headerButtonText" />
            </IonButtons>
            <IonTitle>Help Centre</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen className="helpCentrePageContent">
          {contentLayout}
        </IonContent>
      </IonPage>
    );
  }
}

export default withRouter(withIonLifeCycle(HelpCentrePage));
